/**
 * Procedure Categories and Procedures for MD in Tropical Medicine students
 * Extracted with strict evidence from official NMC PDF (Page 3: "practical skills" & "Laboratory skills")
 */
export const TROPICAL_MEDICINE_PROCEDURES = {
  "Diagnostic & Therapeutic Bedside Procedures": [
    "Cardiopulmonary Resuscitation (CPR), ACLS & Endotracheal Intubation",
    "Diagnostic & Therapeutic Thoracocentesis (Pleural Tap)",
    "Abdominal Paracentesis (Ascitic Tap)",
    "Lumbar Puncture",
    "Bone Marrow Aspiration & Trephine Bone Biopsy",
    "Fine-Needle Aspiration (FNA) of Lymph Node",
    "Short-Term Peritoneal Dialysis",
    "Arterial Puncture, Central & Peripheral Venous Cannulation",
    "Nasogastric (NG) Tube Placement",
    "Indwelling Urinary Catheter Placement",
  ],
  "Laboratory Diagnostic Procedures": [
    "Cell Count on Body Fluids (CSF, Pleural, Peritoneal Fluid)",
    "Sputum AFB Staining & Microscopy",
    "Stool Concentration & Microscopy for Parasites",
    "Identification of Haemoparasites (Malarial Parasites / Microfilaria)",
    "Bacterial Cultures & Sample Inoculation",
    "Basic Laboratory Diagnostic Techniques (ELISA & PCR)",
  ],
};

export const TROPICAL_MEDICINE_CATEGORIES = Object.keys(TROPICAL_MEDICINE_PROCEDURES);

export const isMDInTropicalMedicineDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("tropical medicine") || d.includes("tropical");
};

export const isDiplomaInTropicalMedicineDept = isMDInTropicalMedicineDept;
